module.exports = "/assets/data/dff05f5754f2c35b13292408c5a13253-CT20.data.json";